import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initAdGuard } from './common/ad-guard'

initAdGuard()

// import {VTooltip, VPopover, VClosePopover} from 'v-tooltip'

// createApp(App).use(store).use(VTooltip).use(VPopover).use(VClosePopover).use(router).mount('#app')
createApp(App).use(store).use(router).mount('#app')